export const tutorialSteps = [
    {
      selector: '.add-nodes-button',
      content: 'Click here to start adding nodes to the canvas.',
    },
    {
      selector: '.algorithm-select',
      content: 'Select an algorithm from this dropdown to determine the route optimization method.',
    },
    {
      selector: '.run-algorithm-button',
      content: 'After selecting an algorithm, click here to run it.',
    },
    {
      selector: '.play-pause-button',
      content: 'Smart Play/Pause button: During execution, it pauses/resumes. When idle, it runs the construction algorithm (if no tour) or local search (if tour exists). It\'s a quick way to continue your workflow!',
    },
    {
      selector: '.speed-slider',
      content: 'Adjust the slider to change the speed of the visualization.',
    },
    {
      selector: '.local-search-select',
      content: 'Choose a local search algorithm from this dropdown to further optimize the route.',
    },
    {
      selector: '.run-local-search-button',
      content: 'Click here to run the selected local search algorithm. This button is disabled until you have a tour.',
    },
    {
      selector: '.remove-edges-button',
      content: 'Remove edges while keeping nodes.',
    },
  ];
  